
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4bea"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4bea"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $4rPAP = parcelRequire("4rPAP");

var $jHQpJ = parcelRequire("jHQpJ");

var $mDWTX = parcelRequire("mDWTX");
(async ()=>{
    const btc_data = (0, $mDWTX.Utils).parseData([
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jHQpJ))),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($4rPAP)))
    ]);
    // Set date.
    (0, $mDWTX.Utils).setElementText('date', new Date(btc_data[btc_data.length - 1].x).toISOString().slice(0, 10));
    const dma200 = (0, $mDWTX.Utils).calculateMovingAverage(btc_data, 200);
    const offset = btc_data.length - dma200.length;
    const mayer_multiple = dma200.map((val, i)=>({
            x: val.x,
            y: btc_data[i + offset].y / val.y
        }));
    const mayer_band_1 = dma200.map((val)=>({
            x: val.x,
            y: 0.5 * val.y
        }));
    const mayer_band_2 = dma200;
    const mayer_band_3 = dma200.map((val)=>({
            x: val.x,
            y: 2.0 * val.y
        }));
    const mayer_band_4 = dma200.map((val)=>({
            x: val.x,
            y: 4.0 * val.y
        }));
    (0, $mDWTX.Utils).createChart({
        elementId: 'mayer',
        buttonPrefix: 'mayer',
        btcData: btc_data,
        datasets: [
            {
                label: 'USD/BTC',
                data: btc_data,
                borderWidth: 1
            },
            {
                label: 'Oversold',
                data: mayer_band_1,
                fill: 'origin'
            },
            {
                label: 'Bearish',
                data: mayer_band_2,
                fill: '-1'
            },
            {
                label: 'Bullish',
                data: mayer_band_3,
                fill: '-1'
            },
            {
                label: 'Overbought',
                data: mayer_band_4,
                fill: '-1'
            },
            {
                label: 'Mayer Multiple',
                data: mayer_multiple,
                yAxisID: 'y1'
            }
        ],
        y1: {
            max: 15,
            title: 'Mayer Multiple'
        }
    });
    // Set current info.
    (0, $mDWTX.Utils).setElementText('mayer-multiple-info', ()=>{
        const lastEntry = mayer_multiple[mayer_multiple.length - 1];
        let text = `Mayer Multiple ${(0, $mDWTX.Utils).toTwoDecimals(lastEntry.y)} (`;
        if (lastEntry.y < 0.5) text += 'Oversold';
        else if (lastEntry.y < 1.0) text += 'Bearish';
        else if (lastEntry.y < 2.0) text += 'Bullish';
        else text += 'Overbought';
        return `${text})`;
    });
})();


//# sourceMappingURL=coingraphs.cea43217.js.map
